import React from "react";
import { Button, Modal, Form, InputGroup } from "react-bootstrap";
import { PlusIconWhite } from "../ui/icons";
import { useCreatePublicToken } from "./useCreatePublicToken";
import { TokenExpiryOption } from "./createPublicTokenSlice";


const CreatePublicTokenModal: React.FC<{}> = () => {
  const {
    showCreateModal,
    showGeneratedModal,
    tokenName,
    setTokenName,
    tokenExpiry,
    setTokenExpiry,
    generatedToken,
    handleOpenCreateModal,
    handleCloseCreateModal,
    handleCloseGeneratedModal,
    handleCreateToken,
    handleCopy,
    isLoading
  } = useCreatePublicToken();

  return (
    <>
      <Button onClick={handleOpenCreateModal}>
        <PlusIconWhite /> Create Token
      </Button>

          <Modal show={showCreateModal} onHide={handleCloseCreateModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Create Token</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleCreateToken}>
          <Modal.Body>
            <Form.Group>
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter token name"
                value={tokenName}
                onChange={(e) => setTokenName(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group className="mt-3">
              <Form.Label>Token Expiry</Form.Label>
              <Form.Select
                value={tokenExpiry}
                onChange={(e) => setTokenExpiry(e.target.value as TokenExpiryOption | "")}
                required
              >
                <option value="">Select expiry period</option>
                <option value="six months">Six months</option>
                <option value="one year">One year</option>
                <option value="three years">Three years</option>
                <option value="five years">Five years</option>
                <option value="never">Never</option>
              </Form.Select>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button className="button-bg-white" onClick={handleCloseCreateModal}>
              Cancel
            </Button>
            <Button className="button-bg-blue" type="submit" disabled={isLoading}>
              {isLoading ? "Creating..." : "Save"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* Step 2: Generated Token Modal */}
      <Modal show={showGeneratedModal} onHide={handleCloseGeneratedModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Generated Token</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-4">
            <strong>Note: This token will not be available once this pop-up window is closed.</strong>
          </div>
          <InputGroup>
            <Form.Control value={generatedToken} readOnly />
            <Button variant="outline-secondary" onClick={handleCopy}>
              Copy
            </Button>
          </InputGroup>
          <div className="mt-2 text-muted">
            {tokenExpiry === "never" 
              ? "This token will never expire." 
              : `Token expires ${tokenExpiry} from creation.`}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="button-bg-blue" onClick={handleCloseGeneratedModal}>Close</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CreatePublicTokenModal;
